module.exports = __webpack_public_path__ + "static/media/filler2.1c3f444a.jpg";